function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getPanelPadding = panelPadding => panelPadding ? {
  padding: panelPadding
} : {
  paddingX: {
    s: 'xxl',
    xs: 's'
  },
  paddingY: {
    xs: 's',
    s: 'xl',
    xl: 'xxl'
  }
};

export var splitScreenTheme = {
  baseStyle: _ref => {
    var {
      panelPadding
    } = _ref;
    return {
      container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        _loading: {
          justifyContent: 'center',
          alignItems: 'center'
        }
      },
      resizableBar: {
        flexBasis: '1px',
        flexShrink: '0',
        flexDirection: 'column',
        position: 'relative',
        outline: 'none',
        transition: 'background-color 0.2s ease-in-out',
        backgroundColor: 'neutral.light',
        '&[data-resize-handle-active]': {
          backgroundColor: 'neutral.dark'
        }
      },
      handle: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'neutral.lighter',
        padding: 'xxs',
        borderRadius: 'm'
      },
      panel: {
        height: {
          l: '100%',
          xs: 'initial'
        },
        display: 'flex',
        flexDirection: 'column',
        overflow: {
          l: 'initial',
          xs: 'auto'
        },
        flexGrow: {
          l: 'initial',
          xs: '1'
        },
        _loading: {
          justifyContent: 'center',
          alignItems: 'center'
        }
      },
      panelHeader: {
        display: 'flex',
        flexShrink: 0
      },
      panelFooter: {
        display: 'flex',
        flexShrink: 0
      },
      panelContent: _objectSpread(_objectSpread({}, getPanelPadding(panelPadding)), {}, {
        flexGrow: '1',
        overflow: {
          l: 'auto',
          xs: 'initial'
        }
      })
    };
  }
};
//# sourceMappingURL=SplitScreen.theme.js.map